import { useState } from 'react'
import { useSelector } from 'react-redux'

import Dialog from '@/components/Dialog'
import { translate } from '@/utils/translations'

import DetailsButton from './DetailsButton'

const DetailsDialog = () => {
  const [isShowing, setIsShowing] = useState(false)
  const promoCodeDetails = useSelector(
    state => state.cart.promoCode.details
  )

  return (
    <If condition={promoCodeDetails}>
      <Dialog
        heading={translate('promo_code.dialog.button')}
        id='promo-code-details-dialog'
        isShowing={isShowing}
        onChangeShow={setIsShowing}
        trigger={<DetailsButton />}
      >
        <div>{promoCodeDetails}</div>
      </Dialog>
    </If>
  )
}

export default DetailsDialog
